import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Builder from "@/pages/Builder";
import Admin from "@/pages/Admin";
import Samples from "@/pages/Samples";

function App() {
  return (
    <div className="App grain">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Builder />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/samples/:productId" element={<Samples />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
